/* Fit guard: picks the message for the signed-in customer and enforces the
   age rules on the product page. The date comes from data-fit-date (customer
   metafield fit.last_confirmed). Never shows measurements. Rules and bands:
   under 12 months ok, 12-24 tick, 24-36 tick + staff check + max 2 pairs,
   over 36 months booking only. Staff also get a hidden line item property. */
(function () {
  'use strict';
  var root = document.querySelector('[data-fit-guard]');
  if (!root) return;

  var role = root.getAttribute('data-theme-role');
  var signedIn = root.getAttribute('data-signed-in') === 'true';
  var date = root.getAttribute('data-fit-date') || '';

  // Test override, only on unpublished/development themes, never on the live theme.
  if (role !== 'main' && window.URLSearchParams) {
    var q = new URLSearchParams(window.location.search);
    if (q.has('fit_test')) {
      var t = q.get('fit_test');
      if (t === 'guest') { signedIn = false; date = ''; }
      else if (t === 'nofit') { signedIn = true; date = ''; }
      else { signedIn = true; date = t; }
    }
  }

  var valid = /^\d{4}-\d{2}-\d{2}$/.test(date);
  var state;
  if (!signedIn) state = 'guest';
  else if (!valid) state = 'nofit';
  else {
    var days = (Date.now() - new Date(date + 'T12:00:00').getTime()) / 864e5;
    if (days < 365.25) state = 'ok';
    else if (days < 730.5) state = 'tick';
    else if (days < 1095.75) state = 'staff';
    else state = 'book';
  }

  var lang = document.documentElement.lang || 'en';
  var pretty = date;
  if (valid) {
    try { pretty = new Date(date + 'T12:00:00').toLocaleDateString(lang, { month: 'long', year: 'numeric' }); } catch (e) {}
  }
  var nodes = root.querySelectorAll('[data-fit-date-text]');
  for (var i = 0; i < nodes.length; i++) nodes[i].textContent = pretty;

  var msgs = root.querySelectorAll('[data-fit-state]');
  for (var j = 0; j < msgs.length; j++) {
    msgs[j].hidden = msgs[j].getAttribute('data-fit-state') !== state;
  }
  root.setAttribute('data-fit-active', state);

  var form = root.closest('form');
  var addBtn = form && form.querySelector('#product-add input[type="submit"]');
  var needsTick = state === 'tick' || state === 'staff';
  var box = root.querySelector('#fit-guard-confirm');
  var wrap = root.querySelector('[data-fit-confirm]');

  // Hidden property for staff: the date the fit was last confirmed.
  if (form && signedIn && valid) {
    var h = document.createElement('input');
    h.type = 'hidden'; h.name = 'properties[_Fit last confirmed]'; h.value = date;
    form.appendChild(h);
  }

  if (needsTick && box && wrap) {
    wrap.hidden = false;
    box.value = pretty;
    var sync = function () { if (addBtn) { addBtn.disabled = !box.checked; addBtn.classList.toggle('fit-guard-disabled', !box.checked); } };
    box.addEventListener('change', sync);
    sync();
  }

  if (state === 'book' && addBtn) {
    addBtn.disabled = true;
    addBtn.classList.add('fit-guard-disabled');
    addBtn.title = 'Book a fit check to order these pants';
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      if (state === 'book' || (needsTick && box && !box.checked)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  // Up to two pairs while the fit is 24 to 36 months old. The theme builds the
  // quantity control after this script runs, so apply the limit again once the
  // page has loaded, and a little later for slow controls.
  function limitQty() {
    if (state !== 'staff' || !form) return;
    var qty = form.querySelector('select[name="quantity"], input[name="quantity"]');
    if (!qty) return;
    if (qty.tagName === 'SELECT') {
      for (var k = qty.options.length - 1; k >= 0; k--) if (parseInt(qty.options[k].value, 10) > 2) qty.remove(k);
      if (parseInt(qty.value, 10) > 2) qty.value = '2';
    } else {
      qty.max = '2';
      if (parseInt(qty.value, 10) > 2) qty.value = '2';
    }
  }
  limitQty();
  window.addEventListener('load', function () { limitQty(); setTimeout(limitQty, 700); });
})();
